import isEmail from 'isemail';

export function isValidEmail(emailValue: string) {
  return isEmail.validate(emailValue, { minDomainAtoms: 2 });
}
